import Layout from 'components/layout/Layout';
import { Typography } from "@mui/material";

export default function Error404() {
    return (
        <Layout>
            <Typography variant='h1'>Sorry, Can't find your page</Typography>
        </Layout>
    )
}